import { Component, Inject, OnInit, } from "@angular/core";
import { IwgSelectService } from "../../shared/services/iwgselect.service";
import {IWGSharedService} from '../../shared/services/shared.service';
import { IwgSelect } from "../../shared/models/iwgselect.model";
import { UserService } from "src/app/shared/services/user.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { SalesService } from "src/app/shared/services/sales.service";
import { catchError } from "rxjs/operators";
import { IfStmt } from "@angular/compiler";
import { BaseService } from "src/app/shared/services";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";

@Component({
  selector: "app-us-eor-quotes-dialog",
  templateUrl: "./us-eor-quotes-dialog.component.html",
  styleUrls: ["./us-eor-quotes-dialog.component.scss"],
})
export class UsEorQuotesDialogComponent implements OnInit {
  FormDataStep1!: FormGroup;
  FormDataStep2!: FormGroup;
  salesOption: any;
  salesStateOption: any;
  moveToNextStep: any;
  StepIndex: any;
  isSubmitted: boolean = false;
  props: any;
  existingUsEorQuoteId = null;
  preselectedSalesExecutiveItemId =null;
  LineItemsAdded = false;
  Ready: boolean = false;
  serviceId: any = null;
  Quote: any;
  new_state: any = "";
  items: any;
  name;
  quoteLineItem:any;
  OverridenMarkupNew:any;
  OverridenMarkup:any;
  WizardTitle = "Sales Quote";
  AssignmentLabel = "Initiate New Quote";
  AssignmentLabelLC = "engagement";
  PayAmountTitle = "Amount";
  quoteView=[];
  existingAssignmentId = null;
  isLoading = false;
  maxSteps = 5;
  selectedStepIndex = 0;
  invoiceLineItem:any;
  expat_nationality_id = null;
  statusId=0;
  focusedCtrl = '';
  preselectedQuoteId:any = null;
  quotesSimple: IwgSelect[] = [];
  // step2:{
    QuoteMinimumMarkup = 0;
    QuoteOverridenMarkup = 0;
    QuoteOverridenMarkupNew = 0;
    QuoteMinimumRevenue = 0;
    QuoteOverridenRevenue = 0;
    QuoteMinimumGrossProfit = 0;
    QuoteOverridenGrossProfit = 0;
    QuoteMinimumSalesCommission = 0;
    QuoteOverridenSalesCommission = 0;
    QuoteMinimumSalesCommissionSecondary = 0;
    QuoteOverridenSalesCommissionSecondary = 0;
    QuoteMinimumProfit = 0;
    QuoteOverridenProfit = 0;
    QuoteMinimumReturnOnSales = 0;
    QuoteOverridenReturnOnSales = 0;
  // }
  numberOfSteps = 3;
  Hposition:MatSnackBarHorizontalPosition = "right";
  VPosition:MatSnackBarVerticalPosition = "top";
  constructor(
    private quote: IwgSelectService,
    private user: UserService,
    private fb: FormBuilder,
    private salesService: SalesService,
    private baseService: BaseService,
    public router: Router,
    private sharedService: IWGSharedService,
    private dialogRef: MatDialogRef<UsEorQuotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private toast:MatSnackBar,
  ) {
    this.name = data;
  }

  ngOnInit(): void {
    this.createForm();
    this.preselectedSalesExecutiveItemId =null;
    if(this.name && this.name.usEorQuoteId){
      this.existingUsEorQuoteId=this.name.usEorQuoteId
      this.salesUpdateList();
    }
    this.onItem()
    this.salesItem()
  }
  
  salesUpdateList(){
    return this.salesService
      .getSalesById(this.name.usEorQuoteId)
      .pipe(
        catchError((err) => {
          throw err;
        })
      )
      .subscribe(
        (result) => {
       this.Quote=result.data.Data;
       this.editForm(this.Quote,false);
        },
        (error) => {
          console.log(error);
        }
      );
  }
  onItem(){
    const param = { country_id: "DC5BD5B9-D52E-445B-8650-794F6C3F15BD" };
    this.baseService
      .getEntityData("STATE", param)
      .pipe(
        catchError((err) => {
          console.log("There was an error getting data in component", err);
          throw err;
        })
      )
      .subscribe(
        (result) => {
          if (result.apiCallStatus && result.data) {
            this.items = result.data.Data;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
  salesItem(){
    this.salesOption = [];
    this.isLoading=true;
    const defaultParams = {
      limit: 0,
    };
    this.salesService
      .getSalesItems(defaultParams)
      .pipe(
        catchError((err) => {
          throw err;
        })
      )
      .subscribe(
        (result) => {
          this.isLoading=false;
          if (result.apiCallStatus && result.data) {
            this.salesOption = result.data.Data;            
            if(this.preselectedSalesExecutiveItemId && this.preselectedSalesExecutiveItemId!==null){
               this.FormDataStep1.controls.secondary_sales_exec.patchValue(this.salesOption.find(item=>item.id == this.preselectedSalesExecutiveItemId));
            }
            
          }
        },
        (error) => {
          // this.loading = false;
        }
      );
  }
  createForm() {
    this.FormDataStep1 = this.fb.group({
      title: [null, [
        Validators.required
      ]],
      client_name: ["", [
        Validators.required
      ]],
      end_client: [""],
      commission_percent: ["", [
        Validators.required
      ]],
      secondary_sales_exec: [""],
      commission_percent_secondary: [""],
      notes: [""],
      selectedQuoteSimple: [""],
      status_id: 0,
    });
    this.FormDataStep2 = this.fb.group({
      new_title: [null],
      new_number_of_workers: [0,[
        Validators.required
      ]],
      new_start_date: ["",[
        Validators.required
      ]],
      new_end_date: ["",[
        Validators.required
      ]],
      new_weekly_hours: [0,[
        Validators.required
      ]],
      new_hourly_rate: [0,[
        Validators.required
      ]],
      new_number_of_8810: [0],
      new_number_of_8810_plus: [0],
      new_number_of_8810_other: [0],
      new_number_of_regular: [0,[
        Validators.required
      ]],
      new_number_of_sporadic: [0],
      new_notes: [""],
      new_street1: [""],
      new_street2: [""],
      new_city: [""],
      new_state: [-1,[
        Validators.required
      ]],
      new_postal_code: [""],
    });
  }
  editForm(item:any,flag) {
    this.quoteView=item.USEORQuoteLineItems;


    this.FormDataStep1 = this.fb.group({
      title: [item.Title],
      client_name: [item.ClientName],
      end_client: [(item.EndClient != null)?item.EndClient:''],
      commission_percent: [(item.CommissionPercent!=null)?item.CommissionPercent:0],
      secondary_sales_exec: [""],
      commission_percent_secondary: [(item.CommissionPercentSecondary != null)?item.CommissionPercentSecondary:0],
      notes: [item.Notes],
      status_id: 0,
    });
    this.preselectedSalesExecutiveItemId = item.SecondarySalesExec!=null?item.SecondarySalesExec:null;
    this.salesItem();
    this.QuoteMinimumMarkup=item.Markup;                  
    this.QuoteOverridenMarkup=item.OverridenMarkup;
    this.QuoteOverridenMarkupNew=item.OverridenMarkup;
    this.QuoteMinimumRevenue=item.Revenue;
    this.QuoteOverridenRevenue=item.OverridenRevenue;
    this.QuoteMinimumGrossProfit=item.GrossProfit;
    this.QuoteOverridenGrossProfit=item.OverridenGrossProfit;
    this.QuoteMinimumSalesCommission=item.SalesCommission;
    this.QuoteOverridenSalesCommission=item.OverridenSalesCommission;
    this.QuoteMinimumSalesCommissionSecondary=item.SalesCommissionSecondary;
    this.QuoteOverridenSalesCommissionSecondary=item.OverridenSalesCommissionSecondary;
    this.QuoteMinimumProfit=item.Profit;
    this.QuoteOverridenProfit=item.OverridenProfit;
    this.QuoteMinimumReturnOnSales=item.ReturnOnSales;
    this.QuoteOverridenReturnOnSales=item.OverridenReturnOnSales;
    if(!flag){
      this.FormDataStep2 = this.fb.group({
        new_title: [''],
        new_number_of_workers: [0],
        new_start_date: [null],
        new_end_date: [null],
        new_weekly_hours: [0],
        new_hourly_rate: [0],
        new_number_of_8810: [0],
        new_number_of_8810_plus: [0],
        new_number_of_8810_other: [0],
        new_number_of_regular: [0],
        new_number_of_sporadic: [0],
        new_notes: [''],
        new_street1: [''],
        new_street2: [''],
        new_city: [''],
        new_state: [0],
        new_postal_code: [''],
      });
    }
    if (this.quoteView.length > 0)
      {
          this.LineItemsAdded = true;
      }
  }
  loadQuotes() {
    this.quote
      .getQuotes({
        format_hint: "price_list_drop_down",
        service_type_id: null,
      })
      .subscribe(
        (data) => {
          this.quotesSimple = data.data.Data;
        },
        (err) => {
          console.log("Err :: ", err);
        }
      );
  }

  onselectedQuoteChange(selected) {
    let id = selected.value;
  }

  nextStep(moveToNextStep): void {
    let canProceed = false;
    let stepIndex = this.selectedStepIndex + 1;

    switch (stepIndex) {
      case 1:
        if (
          0.25 *
            Math.floor(this.FormDataStep1.value.commission_percent / 0.25) !=
          this.FormDataStep1.value.commission_percent
        ) {
          alert("Primary commission percent must be a multiple of 0.25%");
          return;
        }
        if (
          0.25 *
            Math.floor(
              this.FormDataStep1.value.commission_percent_secondary / 0.25
            ) !=
            this.FormDataStep1.value.commission_percent_secondary &&
          this.FormDataStep1.value.commission_percent_secondary != null
        ) {
          alert("Secondary commission percent must be a multiple of 0.25%");
          return;
        }
        if (
          this.FormDataStep1.value.commission_percent_secondary != null &&
          this.FormDataStep1.value.commission_percent_secondary != 0 &&
          (this.FormDataStep1.value.secondary_sales_exec == null  ||
            this.FormDataStep1.value.secondary_sales_exec == "" ||
            this.FormDataStep1.value.secondary_sales_exec == -1)
        ) {
          alert(
            "You must select a 2nd sales exec since you provided the 2nd sales exec commission"
          );
          return;
        }
        if (
          this.FormDataStep1.value.commission_percent_secondary == null &&
          this.FormDataStep1.value.secondary_sales_exec != null &&
          this.FormDataStep1.value.secondary_sales_exec != ""
          && this.FormDataStep1.value.secondary_sales_exec !=-1
        )  {
          alert(
            "You must select a 2nd sales commission for the 2nd sales exec"
          );
          return;
        }

        // this.FormDataStep1.valid;
        canProceed = this.FormDataStep1.valid;
        break;
      case 2:
        if(this.FormDataStep2.value.new_state==-1){
          return
        }
        if (
          this.FormDataStep2.value.QuoteOverridenMarkupNew !=
            this.FormDataStep2.value.QuoteOverridenMarkup &&
          this.FormDataStep2.value.QuoteOverridenMarkupNew != "" &&
          this.FormDataStep2.value.QuoteOverridenMarkupNew != null &&
          this.FormDataStep2.value.QuoteOverridenMarkupNew != 0
        ) {
          alert(
            "You must either calculate the markup override or remove it before saving."
          );
          return;
        }
        if (
          Number(this.FormDataStep2.value.new_number_of_8810) +
            Number(this.FormDataStep2.value.new_number_of_8810_plus) +
            Number(this.FormDataStep2.value.new_number_of_8810_other) !=
          Number(this.FormDataStep2.value.new_number_of_workers)
        ) {
          alert(
            "Number of 8810, 8810+, and Other workers much match the total number of workers"
          );
          return;
        }
        if (
          Number(this.FormDataStep2.value.new_number_of_regular) +
            Number(this.FormDataStep2.value.new_number_of_sporadic) !=
          Number(this.FormDataStep2.value.new_number_of_workers)
        ) {
          alert(
            "Number of sporadic workers along with the number of regular scheduled workers must match the total number of workers"
          );
          return;
        }
        //if (new Date(this.FormDataStep2.value.new_start_date) >  new Date(this.FormDataStep2.value.new_end_date))
        if (
          this.FormDataStep2.value.new_start_date >
          this.FormDataStep2.value.new_end_date
        ) {
          alert("Start date must be before the end date");
          return;
        }

        // $scope.usEorQuoteStep2.$setSubmitted();
        canProceed = this.FormDataStep2.valid;
        break;
      case 4:
        //$scope.usEorQuoteStep4.$setSubmitted();
        //canProceed = $scope.usEorQuoteStep4.$valid;
        break;
    }
    var skipSaving = moveToNextStep && (stepIndex == 2 || stepIndex == 3);
    if (skipSaving) {
      let index =
        this.selectedStepIndex == this.maxSteps
          ? 0
          : this.selectedStepIndex + 1;
      this.selectedStepIndex = index;
    } else if (canProceed || stepIndex == 2 || stepIndex == 3) {
      let index =
        this.selectedStepIndex == this.maxSteps
          ? 0
          : this.selectedStepIndex + 1;
      this.moveToNextStep = moveToNextStep;
      this.StepIndex = index;
      this.saveDraft();
    }
  }

  prevStep(): void {
    this.selectedStepIndex -= 1;
  }
  canProceed() {
    let step = this.selectedStepIndex + 1;

    //For step 2, a state must be selected.
    if (step == 2)
    {
        if (this.FormDataStep2.value.new_state == null)
        {
            return false;
        }
        if (this.FormDataStep2.value.new_state.ID == null)
        {
            return false;
        }
        if(this.FormDataStep2.value.new_hourly_rate <= 0){
          return false;
        }
        if(this.FormDataStep2.value.new_weekly_hours <= 0){
          return false;
        }
    }

    let valid = true;
    if (this["FormDataStep" + step]) {
      valid = this["FormDataStep" + step].valid;
    }
// console.log(this["FormDataStep" + step],"this[",step)
    return valid;
  }
  saveDraft() {
    this.statusId = 1;
    return this.save(this.statusId);
  }
  save(statusId) {
    this.isLoading = true;
    this.props = {
      new_status_id: statusId,
    };
    if (this.FormDataStep1.valid) {
      let valstep1 = this.FormDataStep1.value;
      this.props = {
        title: valstep1.title,
        client_name: valstep1.client_name,
        end_client: valstep1.end_client != null ? valstep1.end_client : "",
        commission_percent:
          valstep1.commission_percent != null ? valstep1.commission_percent : 0,
        commission_percent_secondary:
          valstep1.commission_percent_secondary != null
            ? valstep1.commission_percent_secondary
            : 0,
        secondary_sales_exec:
          valstep1.secondary_sales_exec != null
            ? valstep1.secondary_sales_exec.id
            : null,
        notes: valstep1.notes,
        new_status_id: statusId,
      };
    }

    if (this.FormDataStep2.valid) {
      let valstep1 = this.FormDataStep1.value;
      let valstep2 = this.FormDataStep2.value;
      if(this.FormDataStep2.value.new_state !== -1){
        this.props = {         
          title: valstep1.title,
          client_name: valstep1.client_name,
          end_client: valstep1.end_client != null ? valstep1.end_client : "",
          commission_percent:
            valstep1.commission_percent != null ? valstep1.commission_percent : 0,
          commission_percent_secondary:
            valstep1.commission_percent_secondary != null
              ? valstep1.commission_percent_secondary
              : 0,
          secondary_sales_exec:
              valstep1.secondary_sales_exec != null
                ? valstep1.secondary_sales_exec.id
                : null,
         // notes: valstep1.notes,
          new_status_id: statusId,
          quote_id: this.FormDataStep1.value.us_eor_quote_id,
          // title: valstep2.new_title,
          start_date: valstep2.new_start_date,
          end_date: valstep2.new_end_date,
          number_of_workers: valstep2.new_number_of_workers,
          hours_per_week: valstep2.new_weekly_hours,
          hourly_payrate: valstep2.new_hourly_rate,
  
          //workers_comp: valstep2.new_workers_comp,
          number_of_8810: valstep2.new_number_of_8810,
          number_of_8810_plus: valstep2.new_number_of_8810_plus,
          number_of_8810_other: valstep2.new_number_of_8810_other,
  
          //sporadic: valstep2.new_sporadic,
          number_of_regular: valstep2.new_number_of_regular,
          number_of_sporadic: valstep2.new_number_of_sporadic,
  
          street1: valstep2.new_street1,
          street2: valstep2.new_street2,
          city: valstep2.new_city,
          state: valstep2.new_state.ID,
          postal_code: valstep2.new_postal_code,
          notes: valstep2.new_notes,
        };
      }
      
    }

    //Edit or Create Invoice
    if (this.selectedStepIndex == 0) {
      if (this.existingUsEorQuoteId) {
        return this.salesUpdate();
      } else {
        return this.salesQuote();
      }
    }
    //Create New Invoice Line Item
    if (this.selectedStepIndex == 1) {
      return this.salesLineItem();
    }

    //Edit Attachment to put the description on it
    if (this.selectedStepIndex == 2) {
      return this.salesUpdate();
    }

    //Only used for submitting
    if (this.selectedStepIndex == 3) {
      return this.salesUpdate();
     }
  }
  submit() {
    this.statusId = 3;
    return this.save(this.statusId);
  }
  salesUpdate() {
    return this.salesService
      .update(this.existingUsEorQuoteId, this.props)
      .pipe(
        catchError((err) => {
          throw err;
        })
      )
      .subscribe(
        (result) => {
          if (this.selectedStepIndex == 1) {
            this.salesCreate(this.existingUsEorQuoteId,false);
          }
          if(this.selectedStepIndex == 2){
            this.router.navigate(["us-eor-quotes"]);
          }
          if(this.statusId==3){
            if(result.data.ErrorCode==200){              
              this.dialogRef.close();
              this.router.navigate(["us-eor-quotes"]);
              this.showConfirmationToast('Thank you!');
            }else{
             // this.dialogRef.close();
              this.showConfirmationToast('Error submitting form.');
            }
          }
          // if(this.statusId==1){
          //   if(result.data.ErrorCode==200){              
          //     this.dialogRef.close();
          //     this.showConfirmationToast('Draft has been saved.');
          //   }else{
          //     this.dialogRef.close();
          //     this.showConfirmationToast('Error saving draft.');
          //   }
          // }
          this.sharedService.isStateChange.next(true);
          this.statusId
          this.getItem();
          this.moveIndex();
          
        },
        (error) => {
          this.showConfirmationToast('Error submitting form.');
          console.log(error);
        }
      );
  }
  salesCreate(existingUsEorQuoteId,flag:any) {
    this.isLoading=true;
    return this.salesService
      .getSalesById(existingUsEorQuoteId)
      .pipe(
        catchError((err) => {
          throw err;
        })
      )
      .subscribe(
        (result) => {
          this.quoteView=[];
          this.isLoading=false;
          this.Quote = result.data.Data;
          this.quoteView=this.Quote.USEORQuoteLineItems;
          this.QuoteMinimumMarkup=this.Quote.Markup;                  
          this.QuoteOverridenMarkup=this.Quote.OverridenMarkup;
          this.QuoteOverridenMarkupNew=this.Quote.OverridenMarkup;
          this.QuoteMinimumRevenue=this.Quote.Revenue;
          this.QuoteOverridenRevenue=this.Quote.OverridenRevenue;
          this.QuoteMinimumGrossProfit=this.Quote.GrossProfit;
          this.QuoteOverridenGrossProfit=this.Quote.OverridenGrossProfit;
          this.QuoteMinimumSalesCommission=this.Quote.SalesCommission;
          this.QuoteOverridenSalesCommission=this.Quote.OverridenSalesCommission;
          this.QuoteMinimumSalesCommissionSecondary=this.Quote.SalesCommissionSecondary;
          this.QuoteOverridenSalesCommissionSecondary=this.Quote.OverridenSalesCommissionSecondary;
          this.QuoteMinimumProfit=this.Quote.Profit;
          this.QuoteOverridenProfit=this.Quote.OverridenProfit;
          this.QuoteMinimumReturnOnSales=this.Quote.ReturnOnSales;
          this.QuoteOverridenReturnOnSales=this.Quote.OverridenReturnOnSales;
          if ( this.quoteView.length>0)
          {                    
              this.LineItemsAdded = true;
          }
          else
          {                    
              this.LineItemsAdded = false;
          }
    if(this.Quote.USEORQuoteLineItems.length>0){
        this.QuoteOverridenMarkup=this.Quote.USEORQuoteLineItems[0].OverridenMarkup;
        this.QuoteOverridenMarkupNew=this.Quote.USEORQuoteLineItems[0].OverridenMarkup;
    }
      this.editForm(this.Quote,flag)
          if(this.Quote){
            this.existingUsEorQuoteId=this.Quote.ID
          }
          if(this.statusId==3){
            if (result.ErrorCode==200) {
                    this.dialogRef.close();
                      this.showConfirmationToast('Thank you!');
                  } else {
                    //this.dialogRef.close();
            } 
          }          
          // this.getItem();
          // this.moveIndex();
        },
        (error) => {
          this.isLoading=false;
          console.log(error);
        }
      );
  }
  salesQuote() {
    this.isLoading = true;
    return this.salesService
      .updateSalesQoute(this.existingUsEorQuoteId, this.props)
      .pipe(
        catchError((err) => {
          throw err;
        })
      )
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.existingUsEorQuoteId = response.data.Data.ID;
          this.sharedService.isStateChange.next(true);
          this.getItem();
          this.moveIndex();
        },
        (error) => {
          this.isLoading = false;
          console.log(error);
        }
      );
  }
  salesLineItem() {
    this.isLoading = true;
    return this.salesService
      .UsEorQuoteLineItems(this.existingUsEorQuoteId, this.props)
      .pipe(
        catchError((err) => {
          throw err;
        })
      )
      .subscribe(
        (response) => {
          this.isLoading = false;
          if(response.data.Data && response.data.Data.IsSuccessful){
          this.existingUsEorQuoteId = response.data.Data.ID;
          this.FormDataStep2 = this.fb.group({
            new_title: [''],
            new_number_of_workers: [0],
            new_start_date: [null],
            new_end_date: [null],
            new_weekly_hours: [0],
            new_hourly_rate: [0],
            new_number_of_8810: [0],
            new_number_of_8810_plus: [0],
            new_number_of_8810_other: [0],
            new_number_of_regular: [0],
            new_number_of_sporadic: [0],
            new_notes: [''],
            new_street1: [''],
            new_street2: [''],
            new_city: [''],
            new_state: [0],
            new_postal_code: [''],
          }); 
          }
          this.salesCreate(this.existingUsEorQuoteId,false)
          this.moveIndex();
        },
        (error) => {
          this.isLoading = false;
          console.log(error);
        }
      );
  }
  onFocus(control: string) {
    this.focusedCtrl = control;
  }

  onFocusOut(control: string) {
    this.focusedCtrl = '';
  }
  getItem() {
    const defaultParams = {
      end: "2020-12-30T18:30:00.000Z",
      global_scope: 2,
      limit: 25,
      page: 1,
      start: "2019-12-31T18:30:00.000Z",
      status: 0,
    };
    this.isLoading=true;
    this.salesService
      .getItems(defaultParams)
      .pipe(
        catchError((err) => {
          throw err;
        })
      )
      .subscribe(
        (result) => {
          this.isLoading=false;
          if (result.apiCallStatus && result.data) {
            this.salesStateOption = result.data.Data;
          }
        },
        (error) => {
          this.isLoading=false;
        }
      );
  }
  moveIndex() {
    if (this.moveToNextStep) {
      this.selectedStepIndex = this.StepIndex;
    } else {
      this.UpdateLineItemsAndAttachments(false);
    }
  }
  calculateMarkupOverride = () => {                          
    var markupOverride = this.QuoteOverridenMarkupNew;
    var markupCalculated = this.QuoteMinimumMarkup * 100; 
    if (!this.user.getIsSalesManager() && markupOverride < markupCalculated)
    {                               
        alert('Markup override must be larger than the calculated markup');
        return;
    }            
    this.QuoteOverridenMarkup = this.QuoteOverridenMarkupNew;
    var id = this.existingUsEorQuoteId;           
    return this.salesService
    .update(this.existingUsEorQuoteId, {id: id, calculate_override:1, markup_override:markupOverride})
    .pipe(
      catchError((err) => {
        throw err;
      })
    )
    .subscribe(
      (result) => {
        this.sharedService.isStateChange.next(true);
        this.UpdateLineItemsAndAttachments(false)
       },
      (error) => {
        console.log(error);
      }
    );
    // this.selectedStepIndex         
};
deleteLineItem(id:any,flag:boolean){
return this.salesService
.deleteUsEorQuoteLineItemsById(id)
.pipe(
  catchError((err) => {
    throw err;
  })
)
.subscribe(
  (result) => {
    this.isLoading=false;
    this.UpdateLineItemsAndAttachments(flag);
    if(flag){
      const selectedState = this.items.find(state => state.ID == this.invoiceLineItem.StateID);

      this.FormDataStep2 = this.fb.group({
        new_title: [this.invoiceLineItem.Title],
        new_number_of_workers: [this.invoiceLineItem.NumberOfWorkers],
        new_start_date: [new Date(this.invoiceLineItem.StartDate)],
        new_end_date: [new Date(this.invoiceLineItem.EndDate)],
        new_weekly_hours: [this.invoiceLineItem.HoursPerWeek],
        new_hourly_rate: [this.invoiceLineItem.HourlyPayrate],
        new_number_of_8810: [this.invoiceLineItem.NumberOf8810],
        new_number_of_8810_plus: [this.invoiceLineItem.NumberOf8810Plus],
        new_number_of_8810_other: [this.invoiceLineItem.NumberOf8810Other],
        new_number_of_regular: [this.invoiceLineItem.NumberOfRegular],
        new_number_of_sporadic: [this.invoiceLineItem.NumberOfSporadic],
        new_notes: [this.invoiceLineItem.Notes],
        new_street1: [this.invoiceLineItem.Street1],
        new_street2: [this.invoiceLineItem.Street2],
        new_city: [this.invoiceLineItem.City],
        new_state: selectedState,
        new_postal_code: [this.invoiceLineItem.PostalCode],
      });
    }
  },
  (error) => {
    this.isLoading=false;
    console.log(error);
  }
);

}
editLineItem(id:any,flag:boolean){
  this.isLoading=true;
    return this.salesService
      .getUsEorQuoteLineItemsById(id)
      .pipe(
        catchError((err) => {
          throw err;
        })
      )
      .subscribe(
        (result) => {
          this.isLoading=false;
          this.sharedService.isStateChange.next(true);
          this.invoiceLineItem=result.data.Data;          
          this.deleteLineItem(id,true)
        },
        (error) => {
          this.isLoading=false;
          console.log(error);
        }
      );
}
UpdateLineItemsAndAttachments(flag:any){
  this.salesCreate(this.existingUsEorQuoteId,flag)
}
showConfirmationToast(text){
  this.toast.open(text, "Got it", {
    duration: 2000,horizontalPosition:this.Hposition,
    verticalPosition:this.VPosition,
    panelClass: 'iwg-toast-text-white',
  });
}
}
